import {UI} from "../../../../stem-core/src/ui/UIBase";

import {styleRule, styleRuleInherit} from "../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {WalletCard, WalletCardStyle} from "../../ui/WalletCard";
import {Messages} from "../../../Messages";
import {WalletPopup} from "../../ui/WalletPopup";
import {WALLET_CARD_CONTENT_HEIGHT} from "../../WidgetConstants";
import {WidgetRoutes} from "../../WidgetRoutes";
import {apiSetPrimaryPaymentMethod} from "../../../../client/state/PaymentMethodStore";
import {Router} from "../../../../stem-core/src/ui/Router";
import {wrapInSpinner} from "../../../../core/ui/LoadingSpinner.jsx";
import {BlinkButton} from "../../../../core/ui/Button.jsx";
import {StripeCardInput,} from "../../../website/authenticated/pages/wallet/components/cards/StripeCardInput.jsx";


class ElementStyle extends WalletCardStyle {
    @styleRule
    addCardLabel = {
        fontSize: 20,
        fontWeight: "bold",
        marginBottom: 22,
    };

    @styleRuleInherit
    content = {
        height: WALLET_CARD_CONTENT_HEIGHT,
    };
}


@registerStyle(ElementStyle)
export class AddCardClass extends WalletCard {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.addNewPaymentMethod,
        };
    }

    render() {
        return <StripeCardInput ref="cardInput" label=""/>;
    }

    renderPrimaryButton() {
        return (
            <BlinkButton
                disabled={!this.cardInput || !this.cardInput.isLoaded()}
                onClick={() => this.addCard()}
            >
                {Messages.saveNewCard}
            </BlinkButton>
        );
    }

    @wrapInSpinner
    async addCard() {
        const paymentMethod = await this.cardInput.confirmCard();
        await apiSetPrimaryPaymentMethod(paymentMethod.id);
        this.handleCardSuccessfullyAdded();
    }

    handleCardSuccessfullyAdded() {
        if (Router.localHistory.slice(-1)[0].slice(1) === WidgetRoutes.INDEX_COLLAPSED) {
            return;
        }
        Router.back();
    }

    onMount() {
        super.onMount();
        this.cardInput.addListener("load", () => this.redraw()); // TODO @cleanup @input WTF
    }
}

export const AddCard = WalletPopup(AddCardClass);
